import {createSlice} from "@reduxjs/toolkit";
import TableRenderers from 'react-pivottable/TableRenderers';

const initialDeviceLocationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  selectedDevice: undefined,
  trackForSelectedDevice: undefined,
  mode: 'location',
  geofenceGeoJson: {
    "type": "FeatureCollection",
    "features": []
  }, 
  geoJson: {
    "type": "FeatureCollection",
    "features": []
  },
  lastError: null,
  pivotSettings: {
    rows: ['vehicle_owner'],
    cols: ['trip_state'],
    renderers: Object.assign({}, TableRenderers)
  }
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const deviceLocationsSlice = createSlice({
  name: "deviceLocations",
  initialState: initialDeviceLocationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    pivotSettingsChanged: (state, action) => {
      state.pivotSettings = action.payload.pivotSettings;
    },    
    // getDeviceLocationById
    deviceLocationFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    fetchTrack: (state, action) => {
      state.selectedDevice = action.payload.id;
    },
    trackFetched: (state, action) => {
      state.actionsLoading = false;
      const { totalCount, entities } = action.payload;
      console.log("track fetched", action.payload);
      state.trackForSelectedDevice = entities;
      state.error = null;
    },
    // findDeviceLocations
    deviceLocationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // findDeviceLocationsGeoJson
    deviceLocationsGeoJsonFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.geoJson = entities != null && entities.length > 0 ? entities[0].geojson : {
        "type": "FeatureCollection",
        "features": []
    };
      state.totalCount = totalCount;
    },
    // getGeofenceGeoJson
    geofenceGeoJsonFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.geofenceGeoJson = entities != null && entities.length > 0 ? entities[0].geojson : {
        "type": "FeatureCollection",
        "features": []
    };
      state.totalCount = totalCount;
    }
    
  }
});
